import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import MUIDataTable from "mui-datatables";
import DeleteButton from "../components/DeleteButton";
import AddModal from "../components/AddModal";
import { AuthContext } from "../context/auth";
import { Card } from "semantic-ui-react";

import { FETCH_TEAM_QUERY } from "../util/graphql";
import { FETCH_FARM_SYSTEM_QUERY } from "../util/graphql";
import {
  rankBatters,
  rankPitchers,
  sumSalary,
} from "../variables/TableManipulation.js";
import MyPopup from "../util/MyPopup";
const TableAttributes = require("../variables/TableAttributes.js");
// const TableManipulation = require("../variables/TableManipulation.js");

function MyTeam() {
  const { user } = useContext(AuthContext);
  let userId = user.id;
  let get_batters, get_pitchers, total_salary, minors_count, mlb_count;
  const { loading, error, data: mlb } = useQuery(FETCH_TEAM_QUERY);
  const { loading: loading2, error: error2, data: minors } = useQuery(
    FETCH_FARM_SYSTEM_QUERY
  );

  function deletePostCallback() {
    window.location.reload(false);
  }

  if (loading || loading2) return "Loading...";
  if (error || error2)
    return error ? `Error! ${error.message}` : `Error! ${error2.message}`;

  if (!loading2) {
    get_batters = mlb.getTeam
      .filter(
        (o) =>
          o.user === userId && o.pos !== "P" && o.pos !== "SP" && o.pos !== "RP"
      )
      .map((o) => ({
        ...o,
        delete: <DeleteButton postId={o.id} callback={deletePostCallback} />,
        rank: rankBatters[o.pos] ? rankBatters[o.pos] : 10,
      }))
      .sort(function (a, b) {
        return a.rank - b.rank;
      });
    get_pitchers = mlb.getTeam
      .filter(
        (o) =>
          o.user === userId &&
          (o.pos === "P" || o.pos === "SP" || o.pos === "RP")
      )
      .map((o) => ({
        ...o,
        delete: <DeleteButton postId={o.id} callback={deletePostCallback} />,
        rank: rankPitchers[o.pos] ? rankPitchers[o.pos] : 10,
      }));

    // TEAM SUMMARY
    minors_count = minors.getFarmSystem.length;
    mlb_count = mlb.getTeam.length;
    if (minors_count) {
      total_salary = parseFloat(
        sumSalary(mlb.getTeam) + minors_count * 0.5
      ).toFixed(2);
    } else {
      total_salary = parseFloat(sumSalary(mlb.getTeam)).toFixed(2);
    }
  }

  return (
    <div>
      <div style={{ padding: 16 }}>
        <Card>
          <Card.Content header="Team Summary" />
          <Card.Content
            description={
              mlb_count
                ? `Total MLB Players : ${mlb_count}`
                : "Total MLB Players : 0"
            }
          />
          <Card.Content
            description={
              minors_count
                ? `Total Minor League Players : ${minors_count}`
                : "Total Minor League Players : 0"
            }
          />
          <MyPopup
            content={
              minors_count || mlb_count
                ? `Total Minors Players (${minors_count}) : ${
                    minors_count * 0.5
                  } Million  
                  Total Majors Players (${mlb_count}) : ${sumSalary(
                    mlb.getTeam
                  )} Million`
                : "Minors: 0"
            }
          >
            <Card.Content
              description={
                total_salary
                  ? `Combined Salary : ${total_salary} Million`
                  : "Please Fix Salaries"
              }
            />
          </MyPopup>
        </Card>
        <AddModal />
      </div>
      {user && (
        <MUIDataTable
          title={"Batters"}
          data={get_batters}
          columns={TableAttributes.team_columns}
          options={TableAttributes.team_options}
        />
      )}
      <div style={{ marginBottom: "4px" }} />
      {user && (
        <MUIDataTable
          title={"Pitchers"}
          data={get_pitchers}
          columns={TableAttributes.team_columns}
          options={TableAttributes.team_options}
        />
      )}
    </div>
  );
}

export default MyTeam;
